import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import DocumentCounter from '@/components/dashboard/graphic/document-counter/DocumentCounter.component.vue'
import SalesYear from '@/components/dashboard/graphic/sales-year/SalesYear.component.vue'
import Axios from 'axios'
import colors from 'vuetify/lib/util/colors'

const Comp = Component as any

@Comp({
  components: {
    DocumentCounter,
    SalesYear
  }
})
export default class GraphicPageComponent extends Vue {
  years: number[] = []
  yearsSelected: number[] = []
  loadSales: boolean = false
  chartdata: object = {}
  options: object = {
    responsive: true,
    scales: {
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Monto Soles'
          }
        }
      ]
    }

  }

  loadFacturas: boolean = false
  loadBoletas: boolean = false
  loadNotasCredito: boolean = false
  loadNotasDebito: boolean = false
  counterFacturas: number = 0
  counterBoletas: number = 0
  counterNotasCredito: number = 0
  counterNotasDebito: number = 0
  monthNames: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre']
  cacheData: any = {}
  counterStatusAccepted: number = 0
  counterStatusPending: number = 0
  counterStatusRejection: number = 0
  loadStatus: boolean = false

  @Watch('yearsSelected')
  onChangeYears (newYears: number[], oldYears: number[]) {
    if (oldYears.length < newYears.length) {
      const year = this.years[newYears[newYears.length - 1]]
      this.onLoadSalesByYear(year)
    } else {
      const year = this.years[oldYears.filter(year => !newYears.includes(year))[0]]
      delete this.cacheData[year + '']
      this.printGraphic()
      this.loadSales = false
      setTimeout(() => { this.loadSales = true }, 500)
    }
  }

  onCounterFacturas () {
    this.loadFacturas = false
    Axios.get(`/documents/counter/01`).then(response => {
      this.counterFacturas = response.data.counter
      this.loadFacturas = true
    })
  }

  onCounterBoletas () {
    this.loadBoletas = false
    Axios.get(`/documents/counter/03`).then(response => {
      this.counterBoletas = response.data.counter
      this.loadBoletas = true
    })
  }

  onCounterNotasCredito () {
    this.loadNotasCredito = false
    Axios.get(`/documents/counter/07`).then(response => {
      this.counterNotasCredito = response.data.counter
      this.loadNotasCredito = true
    })
  }

  onCounterNotasDebito () {
    this.loadNotasDebito = false
    Axios.get(`/documents/counter/08`).then(response => {
      this.counterNotasDebito = response.data.counter
      this.loadNotasDebito = true
    })
  }

  onLoadSalesByYear (year: number) {
    this.loadSales = false

    Axios.get(`/documents/summary-totals/${year}`).then(response => {
      const data = {
        label: `${year}`,
        borderColor: this.getColorRandom(),
        fill: false,
        data: this.fillData(response.data)
      }
      this.cacheData[year + ''] = data
      this.printGraphic()
      this.loadSales = true
    })
  }

  getColorRandom () {
    const r = Math.floor(Math.random() * 255)
    const g = Math.floor(Math.random() * 255)
    const b = Math.floor(Math.random() * 255)
    return `rgba(${r}, ${g}, ${b}, 1.0)`
  }
  onLoarYears () {
    Axios.get('/documents/years').then(response => {
      this.years = response.data.map((item: any) => item.value)
      this.yearsSelected = [...this.yearsSelected, response.data.length - 1]
    })
  }

  printGraphic () {
    this.chartdata = {
      labels: this.monthNames,
      datasets: Object.values(this.cacheData)
    }
    this.loadSales = true
  }

  fillData (data: any) {
    let template = {
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0
    } as any

    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      template[item.month + ''] = item.total
    }

    return Object.values(template)
  }

  async getStatusAccepted () {
    const response = await Axios.get('/documents/counter/status/A')
    this.counterStatusAccepted = response.data.counter
  }

  async getStatusPending () {
    const response = await Axios.get('/documents/counter/status/P')
    this.counterStatusPending = response.data.counter
  }

  async getStatusRejection () {
    const response = await Axios.get('/documents/counter/status/R')
    this.counterStatusRejection = response.data.counter
  }

  onLoadStatus () {
    this.loadStatus = false
    Promise.all([this.getStatusAccepted(), this.getStatusPending(), this.getStatusRejection()]).then(() => {
      this.loadStatus = true
    }).catch(() => {
      this.loadStatus = true
    })
  }
  mounted () {
    this.onLoarYears()
    this.onLoadSalesByYear(new Date().getFullYear())
    this.onCounterFacturas()
    this.onCounterBoletas()
    this.onCounterNotasCredito()
    this.onCounterNotasDebito()
    this.onLoadStatus()
  }
}
